import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PhotosIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-photos"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M26.0302,14.5185 C26.4782,13.8275 27.5222,13.8275 27.9702,14.5185 L32.5002,21.5105 L38.0002,29.9995 L27.0002,29.9995 L16.0002,29.9995 L21.5002,21.5105 L26.0302,14.5185 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M40.2271,22.3454 C40.6021,21.8854 41.3981,21.8854 41.7731,22.3454 L44.5001,25.6974 L48.0001,30.0004 L41.0001,30.0004 L34.0001,30.0004 L37.5001,25.6974 L40.2271,22.3454 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M46,6 L18,6 C16.3427153,6 15,7.34271525 15,9 L15,29 C15,30.6572847 16.3427153,32 18,32 L46,32 C47.6572847,32 49,30.6572847 49,29 L49,9 C49,7.34271525 47.6572847,6 46,6 Z M18,8 L46,8 C46.5527153,8 47,8.44728475 47,9 L47,29 C47,29.5527153 46.5527153,30 46,30 L18,30 C17.4472847,30 17,29.5527153 17,29 L17,9 C17,8.44728475 17.4472847,8 18,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M50,2 C51.598096,2 52.9036905,3.24851967 52.9949089,4.82368432 L53,5 L53,25 C53,26.598096 51.7514803,27.9036905 50.1763157,27.9949089 L50,28 L50,26 C50.5132356,26 50.9355643,25.614331 50.9932784,25.1167007 L51,25 L51,5 C51,4.48676441 50.614331,4.06443573 50.1167007,4.00672161 L50,4 L22,4 C21.4867644,4 21.0644357,4.38566899 21.0067216,4.88329933 L21,5 L19,5 C19,3.40190399 20.2485197,2.09630947 21.8236843,2.0050911 L22,2 L50,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M38,14 C38,15.657 39.343,17 41,17 C42.657,17 44,15.657 44,14 C44,12.343 42.657,11 41,11 C39.343,11 38,12.343 38,14"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
